// LIST
export const FETCH_PAGES = "app/Pages/FETCH_PAGES";
export const FETCH_PAGES_SUCCESS = "app/Pages/FETCH_PAGES_SUCCESS";
export const FETCH_PAGES_FAILURE = "app/Pages/FETCH_PAGES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Pages/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Pages/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Pages/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_PAGES = "app/Pages/ADD_PAGES";
export const ADD_PAGES_SUCCESS = "app/Pages/ADD_PAGES_SUCCESS";
export const ADD_PAGES_FAILURE = "app/Pages/ADD_PAGES_FAILURE";
// EDIT
export const EDIT_PAGES = "app/Pages/EDIT_PAGES";
export const EDIT_PAGES_SUCCESS = "app/Pages/EDIT_PAGES_SUCCESS";
export const EDIT_PAGES_FAILURE = "app/Pages/EDIT_PAGES_FAILURE";
// DELETE
export const DELETE_PAGES = "app/Pages/DELETE_PAGES";
export const DELETE_PAGES_SUCCESS = "app/Pages/DELETE_PAGES_SUCCESS";
export const DELETE_PAGES_FAILURE = "app/Pages/DELETE_PAGES_FAILURE";
//
export const OPEN_PAGES_ADD_MODAL = "app/Pages/OPEN_PAGES_ADD_MODAL";
export const CLOSE_PAGES_ADD_MODAL = "app/Pages/CLOSE_PAGES_ADD_MODAL";
//
export const OPEN_PAGES_EDIT_MODAL = "app/Pages/OPEN_PAGES_EDIT_MODAL";
export const CLOSE_PAGES_EDIT_MODAL = "app/Pages/CLOSE_PAGES_EDIT_MODAL";

export const TOGGLE_ITEM_MODAL = "app/Pages/TOGGLE_ITEM_MODAL";
export const TOGGLE_SECTION_MODAL = "app/Pages/TOGGLE_SECTION_MODAL";
export const TOGGLE_INNER_SECTION_MODAL =
  "app/Pages/TOGGLE_INNER_SECTION_MODAL";
export const TOGGLE_INNER_ITEM_MODAL = "app/Pages/TOGGLE_INNER_ITEM_MODAL";

export const UPLOAD_FILE = "app/Pages/UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "app/Pages/UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "app/Pages/UPLOAD_FILE_FAILURE";
